import React from "react";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const timeToTriageDayWise = [
  { label: "Mon", avgTime: 4.2 },
  { label: "Tue", avgTime: 4.4 },
  { label: "Wed", avgTime: 4.1 },
  { label: "Thu", avgTime: 4.6 },
  { label: "Fri", avgTime: 4.5 },
  { label: "Sat", avgTime: 5.1 },
  { label: "Sun", avgTime: 4.8 },
];

/* Tooltip */
const TriageTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;

  return (
    <div className="bg-white p-3 rounded-lg shadow-md border text-sm min-w-[150px]">
      <p className="font-semibold mb-1">{label}</p>
      <div className="flex justify-between font-semibold text-blue-900">
        <span>Avg Time :</span>
        <span>{payload[0].value} min</span>
      </div>
    </div>
  );
};

export default function TimeToTriageAreaLineChart() {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <AreaChart
        data={timeToTriageDayWise}
        margin={{ top: 10, right: 10, left: -10, bottom: 0 }}
      >
        {/* Dark Gradient */}
        <defs>
          <linearGradient id="triageDarkGradient" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#1E3A8A" stopOpacity={0.5} />
            <stop offset="100%" stopColor="#1E3A8A" stopOpacity={0} />
          </linearGradient>
        </defs>

        <CartesianGrid
          strokeDasharray="3 3"
          vertical={false}
          stroke="#e5e7eb"
        />

        <XAxis dataKey="label" tick={{ fontSize: 12 }} stroke="#6b7280" />
        <YAxis
          interval={0}
          tick={{ fontSize: 12 }}
          stroke="#6b7280"
          tickFormatter={(v) => `${v}m`}
        />

        <Tooltip content={<TriageTooltip />} />

        <Area
          type="monotone"
          dataKey="avgTime"
          stroke="#1E3A8A"
          fill="url(#triageDarkGradient)"
          strokeWidth={3}
          dot={{
            r: 3,
            stroke: "#1E3A8A",
            strokeWidth: 3,
            fill: "#1E3A8A",
          }}
          activeDot={{ r: 3 }}
        />
      </AreaChart>
    </ResponsiveContainer>
  );
}
